
import { PerformanceChart } from '../components/charts';
import { useWeeklyAverages, useUser } from '../hooks';

export function PerformanceAnalysis() {
  const { selectedPlayer } = useUser();
  const { weeklyData, loading, error } = useWeeklyAverages(selectedPlayer?.bowler_id || null);

  if (!selectedPlayer) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Performance Analysis
          </h1>
          <p className="text-gray-600">
            Weekly performance trends and charts
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            No Player Selected
          </h2>
          
          <p className="text-gray-600">
            Please select a player to view their performance analysis.
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Performance Analysis
          </h1>
          <p className="text-gray-600">
            Weekly performance trends and charts
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Error Loading Data
          </h2>
          
          <p className="text-gray-600 mb-4">
            {error.message}
          </p>
          
          <button 
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Performance Analysis
        </h1>
        <p className="text-gray-600">
          Weekly performance trends and charts for {selectedPlayer.bowler_name}
        </p>
      </div>

      <PerformanceChart 
        weeklyData={weeklyData}
        playerName={selectedPlayer.bowler_name}
        loading={loading}
      />
    </div>
  );
}